import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "pickedInstructorToken"];

  connect() {}

  close(event) {
    event.preventDefault();
    // TODO: 13/8/2025 - We should not be using ids, but I cannot bear to use one of the existing quicklooks
    // so this is a temporary compromise to have a generic quicklook controller.
    const quickLookId = this.data.get("containerId");
    const quickViewElement = document.querySelector(`#${quickLookId}`);
    if (!quickViewElement) {
      console.error("Quick view element not found in the DOM.");
      return;
    }
    quickViewElement.classList.add("u-hidden");
  }
}
